import React from 'react';
import { Button } from '@mui/material';
import T, { bool, func } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { NotifyTypo } from 'web-components';
import { useDispatch } from 'react-redux';
import { deleteLicense } from 'redux/licenses/actions';
import { StyledContent, StyledHandlersCustom, StyledNewDialog } from './elements';
import { COLOR_ERROR } from 'attrs/colors';

const labelAmmend = 'licenses.delete';

const DeleteLicense = ({ open, handleClose, licenseData, organizationId }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const successToastProps = {
    variant: 'success',
    autoHideDuration: 3000
  };

  const errorToastProps = {
    variant: 'error',
    autoHideDuration: 3000
  };

  const handleDeleteMachine = async () => {
    try {
      dispatch(deleteLicense(licenseData.subscription_uuid, organizationId));
      handleClose(true);
      enqueueSnackbar(t('licenses.delete.success'), successToastProps);
    } catch {
      enqueueSnackbar(t('licenses.delete.error'), errorToastProps);
    }
  };

  const actionBar = (
    <StyledHandlersCustom>
      <Button variant="outlined" style={{ padding: '1rem 2.5rem', marginRight: 25 }} onClick={handleClose}>
        {t(`${labelAmmend}.cancel`)}
      </Button>
      <Button
        variant="contained"
        data-selector="license-modal-submit"
        style={{ backgroundColor: COLOR_ERROR, color: 'white', padding: '1rem 2.5rem' }}
        onClick={handleDeleteMachine}
      >
        {t(`${labelAmmend}.action`)}
      </Button>
    </StyledHandlersCustom>
  );

  return (
    <StyledNewDialog
      open={open}
      handleClose={(event, reason) => {
        if (reason === 'backdropClick') return;
        handleClose();
      }}
      title={t(`${labelAmmend}.title`)}
      displayActionBar="block"
      actionBar={actionBar}
      maxWidth="688px"
      content={
        <StyledContent>
          <NotifyTypo.Body1 style={{ color: 'gray', position: 'relative', top: '-30px', marginBottom: 0 }}>
            {t(`${labelAmmend}.subtitle`)}
          </NotifyTypo.Body1>

          <NotifyTypo.Body1>{t(`${labelAmmend}.text`)}</NotifyTypo.Body1>
        </StyledContent>
      }
    />
  );
};

DeleteLicense.propTypes = {
  open: bool.isRequired,
  handleClose: func.isRequired,
  licenseData: T.instanceOf(Object).isRequired,
  organizationId: T.string.isRequired
};

export default DeleteLicense;
